<template>

  <section class="px-12 mt-20 sm-max:px-5 md-max:mt-10" id="testimonial">

    <div class="relative">
      <nuxt-img :src="imageSrc" :alt="imageAlt" class="mx-auto rounded-lg opacity-1" width="992" height="558"
        format="webp" sizes="sm:400px md:100vw lg:100vw xl:1024px" loading="lazy"
        :class="showVideo ? 'opacity-0 duration-150 absolute top-0 left-0 right-0 bottom-0 left-6/12 m-0' : ''"></nuxt-img>
      <button id="play-button-hero" @click="playVid()" v-if="!showVideo" aria-label="Start video"
        class="flex absolute inset-0 flex-col justify-center w-full h-full text-base text-white bg-opacity-75">
        <svg class="m-auto w-32 sm-max:w-12" viewBox="-13 -7 205 151" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_13_831)">
            <rect x="31" y="8" width="120" height="120" rx="60" fill="#FAF7F5" />
            <path
              d="M106.466 65.4079C108.376 66.6081 108.376 69.3919 106.466 70.5921L84.0571 84.6715C82.0185 85.9524 79.3673 84.4871 79.3673 82.0795L79.3673 53.9205C79.3673 51.5129 82.0185 50.0476 84.0571 51.3284L106.466 65.4079Z"
              fill="#f87832" />
          </g>
          <defs>
            <filter id="filter0_d_13_831" x="0.387754" y="0.653061" width="181.224" height="181.224"
              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha" />
              <feOffset dy="23.2653" />
              <feGaussianBlur stdDeviation="15.3061" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.211765 0 0 0 0 0.2 0 0 0 0 0.14902 0 0 0 0.3 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13_831" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13_831" result="shape" />
            </filter>
          </defs>
        </svg>

      </button>

      <div class="m-auto max-w-screen-lg">
        <div id="video-container" class="relative overflow-hidden h-[0px] pb-[56.25%]" v-if="showVideo">
          <iframe v-if="videoPLay" id="myVideo" :src="videoIframeSrc"
            class="absolute top-0 left-0 w-full h-full rounded-3xl" allow="autoplay; fullscreen" allowfullscreen>
          </iframe>
        </div>
      </div>

    </div>

    <div class="pt-2 text-center lg:text-lg text-15 md-max:px-4" v-if="text1" v-html="text1">

    </div>

    <div class="pt-14 text-center font-ww-regular" v-html="text2"
      :class="newStyle ? 'text:xl md-max:pt-4' : 'md:text-lg text-15 lg:text-xl md-max:pt-4 md-max:pb-6'">
    </div>

    <h3 class="pb-4 mt-4 text-center md:mb-4 font-ww-medium md-max:mt-0 md-max:pt-4 sm-max:pb-6">
      <strong v-html="text3" :class="newStyle ? 'text-45 leading-none' : 'text-2xl xl:text-45 md:text-4xl'"></strong>
    </h3>

    <div class="grid grid-cols-2 gap-5 md:pt-4 md-max:grid-cols-1 last-border md:mb-12">
      <div class="col-span-1 pb-2 sm-max:col-span-1 bg-[#F5F5F5] rounded-lg"
        :class="{ '': index !== reviews.length - 2 && index !== reviews.length - 1 }" v-for="(review, index) in reviews"
        :key="index">
        <div class="grid grid-cols-12 gap-6 p-8">
          <div class="col-span-4 mx-auto bg-white sm-max:col-span-12 sm-max:text-center h-fit w-fit"
            :class="newStyle ? 'md-max:!mx-0' : ''">
            <nuxt-img :src="review.productImage" alt="product-1"
              class="border border-[#DCDCDC] w-full rounded-lg sm-max:max-w-32 md-max:m-auto p-2"
              :class="index === 0 ? 'sm-max:w-full' : 'md-max:w-32'" width="112" height="84" format="webp"
              loading="lazy" style="box-shadow: 0px 0px 4px #CCB;"></nuxt-img>
          </div>

          <div class="col-span-8 space-y-2 sm-max:col-span-12 sm-max:text-center">
            <nuxt-img :src="review.ratingImage" alt="rating" class="sm-max:m-auto"
              :class="newStyle ? 'md-max:!mx-0' : ''" width="162" height="32" format="webp" loading="lazy"></nuxt-img>

            <div class="pt-1 font-bold review-item-title xs-max:text-left font-ww-bold" v-html="review.title"
              :class="newStyle ? 'text-xl' : 'sm-max:text-base text-xl'">

            </div>

            <div class="md:leading-5 xs-max:text-left font-ww-regular review-item-message xl:!leading-6"
              v-html="review.message" :class="newStyle ? 'text-17' : 'md:text-17 text-sm'">

            </div>

            <div class="text-15 flex xs-max:!justify-left items-center xs-only:justify-center pb-3 !mt-5">
              <span class="pr-2 font-bold font-ww-medium" :class="newStyle ? 'text-17' : 'text-sm md:text-17'"
                v-html="review.reviewerName">

              </span>

              <nuxt-img :src="review.verifiedIcon" alt="rating" class="relative h-4" width="16" height="17"
                format="webp" loading="lazy"></nuxt-img>

              <span class="text-[#358419] pl-2 text-sm relative font-ww-bold" v-html="textVerified">

              </span>

            </div>

            <div class="text-[11px] !mt-0 font-ww-regular xs-max:text-left" v-html="review.productDetails">

            </div>

          </div>
        </div>
      </div>

      <div class="grid col-span-1 sm-max:col-span-1">

        <nuxt-img :src="organicCoffeeSrc" :alt="organicCoffeeAlt"
          class="py-0 m-auto mx-auto lg:w-full lg:px-12 md-max:w-full md-max:py-0 sm-max:mb-10 md-max:max-w-md"
          format="webp" loading="lazy" width="406" height="319"></nuxt-img>

      </div>


    </div>

  </section>

</template>

<script setup>

import { ref } from 'vue';

const showVideo = ref(false);
const videoPLay = ref(false);

const playVid = () => {
  videoPLay.value = true;
  showVideo.value = true;
};

defineProps({
  imageSrc: {
    type: String,
    default: '/assets/images/video-bg.png'
  },
  imageAlt: {
    type: String,
    default: 'image video'
  },
  videoIframeSrc: {
    type: String,
    default: 'https://player.vimeo.com/video/439100268?autoplay=1#t=0s'
  },
  text1: {
    type: String,
    default: 'Real people experiencing Lifeboost Coffee for the first time (watch above)'
  },
  text2: {
    type: String,
    default: 'I love this coffee so much, I’ve had to share it with everyone I know.'
  },
  text3: {
    type: String,
    default: 'What People Have To Say'
  },
  textVerified: {
    type: String,
    default: 'Verified Buyer'
  },
  reviews: {
    type: Array,
    default: () => [
      {
        productImage: '/assets/images/product-1.png',
        ratingImage: '/assets/images/stars-product.svg',
        title: 'Great Coffee',
        message: 'This coffee is very expensive, and worth every dime. I can drink without adding anything, no sugar or cream. So mellow and tasty! Thank you',
        reviewerName: 'Bonnie B',
        verifiedIcon: '/assets/images/verified-icon-new.jpg',
        productDetails: 'Single Origin Medium Roast Coffee 12 oz Bag - Bundle'
      },
      {
        productImage: '/assets/images/product-2.jpg',
        ratingImage: '/assets/images/stars-product.svg',
        title: 'Good coffee',
        message: 'Great coffee !!!!',
        reviewerName: 'Anita E. ',
        verifiedIcon: '/assets/images/verified-icon-new.jpg',
        productDetails: 'Single Origin Medium Roast Coffee 12 oz Bag - 50% Off Special'
      },
      {
        productImage: '/assets/images/product-3.jpg',
        ratingImage: '/assets/images/stars-product.svg',
        title: 'Delicious',
        message: 'Best coffee out there! Great taste!',
        reviewerName: 'Edward T.',
        verifiedIcon: '/assets/images/verified-icon-new.jpg',
        productDetails: 'Single Origin Espresso Coffee 12 oz Bag'
      },
      {
        productImage: '/assets/images/product-4.jpg',
        ratingImage: '/assets/images/stars-product.svg',
        title: 'Taste & smells just like Grandpa\'s coffee!',
        message: 'Love the product and you certainly can taste the difference.',
        reviewerName: 'Gay M. ',
        verifiedIcon: '/assets/images/verified-icon-new.jpg',
        productDetails: '6x Single Origin Medium Roast Coffee 12 oz Bag'
      },
      {
        productImage: '/assets/images/product-3.jpg',
        ratingImage: '/assets/images/stars-product.svg',
        title: 'Excellent tasting!!',
        message: 'This coffee is great tasting!! Best so far!! ',
        reviewerName: 'Edward T. ',
        verifiedIcon: '/assets/images/verified-icon-new.jpg',
        productDetails: 'Single Origin Espresso Coffee 12 oz Bag'
      },
      {
        productImage: '/assets/images/product-2.jpg',
        ratingImage: '/assets/images/stars-product.svg',
        title: 'Best coffee ever',
        message: 'This coffee is everything they say it is. So smooth no acid at all. So glad I found it.',
        reviewerName: 'Lisa R. ',
        verifiedIcon: '/assets/images/verified-icon-new.jpg',
        productDetails: '1x Single Origin Medium Roast Coffee 12 oz Bag'
      },
      {
        productImage: '/assets/images/product-2.jpg',
        ratingImage: '/assets/images/stars-product.svg',
        title: 'Great coffee, fast delivery!',
        message: 'Lifeboost shipped my order so fast that it felt like my first cup came right off the tree! This was the most vibrant experience of coffee I\'ve ever had, and I highly recommend Lifeboost to anyone who wants to experience coffee as fresh and wonderful as it gets!',
        reviewerName: 'Karen M.  ',
        verifiedIcon: '/assets/images/verified-icon-new.jpg',
        productDetails: '3x Single Origin Medium Roast Coffee 12 oz Bag'
      },
      {
        productImage: '/assets/images/product-5.jpg',
        ratingImage: '/assets/images/stars-product.svg',
        title: 'Life Boost Coffee',
        message: 'Life Boost Coffee is more than just drinking coffee - it’s an experience that no one should miss. It’s smooth with no bitter aftertaste and it’s delightfully pleasant. I’m glad Life Boost Coffee found me.',
        reviewerName: 'Everet K.',
        verifiedIcon: '/assets/images/verified-icon-new.jpg',
        productDetails: '3x Single Origin Medium Roast Coffee 12 oz Bag - One Bag Free'
      },
      {
        productImage: '/assets/images/product-3.jpg',
        ratingImage: '/assets/images/stars-product.svg',
        title: 'My husband love it and',
        message: 'My husband love it and I start drinking coffee too. Knowing it’s kosher and stomach friendly, that’s why I’m confident to drink it.',
        reviewerName: 'Thelma K. ',
        verifiedIcon: '/assets/images/verified-icon-new.jpg',
        productDetails: 'Single Origin Medium Roast Coffee 12 oz Bag - 1st bag free'
      },
      {
        productImage: '/assets/images/product-3.jpg',
        ratingImage: '/assets/images/stars-product.svg',
        title: 'Fabulous Coffee',
        message: 'We love Lifeboost coffee! been buying it for almost two years, with no plan to stop! Great taste, great value! Arrives right on time in super condition.',
        reviewerName: 'Deborah E.',
        verifiedIcon: '/assets/images/verified-icon-new.jpg',
        productDetails: 'Single Origin Dark Roast Coffee 12 oz Bag'
      },
      {
        productImage: '/assets/images/product-6.jpg',
        ratingImage: '/assets/images/stars-product.svg',
        title: 'Best coffee I’ve ever had!!!',
        message: 'This coffee is so good and so much flavor. The decaf process was so clean with no chemicals and still retains the flavor. I served it to guests from Hawaii and he just texted me on how wonderful the coffee was I and I didn’t tell him it was decaf.',
        reviewerName: 'Kathleen M. ',
        verifiedIcon: '/assets/images/verified-icon-new.jpg',
        productDetails: '6x Decaf Coffee 12 oz Bag, Single Origin, Fair Trade Medium Roast\n'
      },
    ]
  },
  organicCoffeeSrc: {
    type: String,
    default: '/assets/images/product-organic.png'
  },
  organicCoffeeAlt: {
    type: String,
    default: 'product-organic'
  },
  buttonText: {
    type: String,
    default: 'Save 50% Now'
  },
  newStyle: {
    type: Boolean,
    default: false
  }
})

defineBuilderComponent({
  friendlyName: "VideoWithCommentBlock",
  canHaveChildren: true,
  inputs: [
    {
      name: "imageSrc",
      type: "file",
      allowedFileTypes: [
        "jpeg",
        "jpg",
        "png",
        "svg"
      ],
      defaultValue: "/assets/images/video-bg.png"
    },
    {
      name: "imageAlt",
      type: "text",
      defaultValue: "image video"
    },
    {
      name: "videoIframeSrc",
      type: "text",
      defaultValue: "https://player.vimeo.com/video/439100268?autoplay=1#t=0s"
    },
    {
      name: "text1",
      type: "richText",
      defaultValue: "Real people experiencing Lifeboost Coffee for the first time (watch above)"
    },
    {
      name: "text2",
      type: "richText",
      defaultValue: "I love this coffee so much, I’ve had to share it with everyone I know."
    },
    {
      name: "text3",
      type: "richText",
      defaultValue: "What People Have To Say"
    },
    {
      name: "textVerified",
      type: "richText",
      defaultValue: "Verified Buyer"
    },
    {
      name: "reviews",
      type: "list",
      subFields: [
        {
          name: "productImage",
          type: "file",
          allowedFileTypes: [
            "jpeg",
            "jpg",
            "png",
            "svg"
          ]
        },
        {
          name: "ratingImage",
          type: "file",
          allowedFileTypes: [
            "jpeg",
            "jpg",
            "png",
            "svg"
          ]
        },
        {
          name: "title",
          type: "richText"
        },
        {
          name: "message",
          type: "richText"
        },
        {
          name: "reviewerName",
          type: "richText"
        },
        {
          name: "verifiedIcon",
          type: "file",
          allowedFileTypes: [
            "jpeg",
            "jpg",
            "png",
            "svg"
          ]
        },
        {
          name: "productDetails",
          type: "richText"
        }
      ],
      defaultValue: [
        {
          productImage: "/assets/images/product-1.png",
          ratingImage: "/assets/images/stars-product.svg",
          title: "Great Coffee",
          message: "This coffee is very expensive, and worth every dime. I can drink without adding anything, no sugar or cream. So mellow and tasty! Thank you",
          reviewerName: "Bonnie B",
          verifiedIcon: "/assets/images/verified-icon-new.jpg",
          productDetails: "Single Origin Medium Roast Coffee 12 oz Bag - Bundle"
        },
        {
          productImage: "/assets/images/product-2.jpg",
          ratingImage: "/assets/images/stars-product.svg",
          title: "Good coffee",
          message: "Great coffee !!!!",
          reviewerName: "Anita E. ",
          verifiedIcon: "/assets/images/verified-icon-new.jpg",
          productDetails: "Single Origin Medium Roast Coffee 12 oz Bag - 50% Off Special"
        },
        {
          productImage: "/assets/images/product-3.jpg",
          ratingImage: "/assets/images/stars-product.svg",
          title: "Delicious",
          message: "Best coffee out there! Great taste!",
          reviewerName: "Edward T.",
          verifiedIcon: "/assets/images/verified-icon-new.jpg",
          productDetails: "Single Origin Espresso Coffee 12 oz Bag"
        },
        {
          productImage: "/assets/images/product-4.jpg",
          ratingImage: "/assets/images/stars-product.svg",
          title: "Taste & smells just like Grandpa's coffee!",
          message: "Love the product and you certainly can taste the difference.",
          reviewerName: "Gay M. ",
          verifiedIcon: "/assets/images/verified-icon-new.jpg",
          productDetails: "6x Single Origin Medium Roast Coffee 12 oz Bag"
        },
        {
          productImage: "/assets/images/product-3.jpg",
          ratingImage: "/assets/images/stars-product.svg",
          title: "Excellent tasting!!",
          message: "This coffee is great tasting!! Best so far!! ",
          reviewerName: "Edward T. ",
          verifiedIcon: "/assets/images/verified-icon-new.jpg",
          productDetails: "Single Origin Espresso Coffee 12 oz Bag"
        },
        {
          productImage: "/assets/images/product-2.jpg",
          ratingImage: "/assets/images/stars-product.svg",
          title: "Best coffee ever",
          message: "This coffee is everything they say it is. So smooth no acid at all. So glad I found it.",
          reviewerName: "Lisa R. ",
          verifiedIcon: "/assets/images/verified-icon-new.jpg",
          productDetails: "1x Single Origin Medium Roast Coffee 12 oz Bag"
        },
        {
          productImage: "/assets/images/product-2.jpg",
          ratingImage: "/assets/images/stars-product.svg",
          title: "Great coffee, fast delivery!",
          message: "Lifeboost shipped my order so fast that it felt like my first cup came right off the tree! This was the most vibrant experience of coffee I've ever had, and I highly recommend Lifeboost to anyone who wants to experience coffee as fresh and wonderful as it gets!",
          reviewerName: "Karen M.  ",
          verifiedIcon: "/assets/images/verified-icon-new.jpg",
          productDetails: "3x Single Origin Medium Roast Coffee 12 oz Bag"
        },
        {
          productImage: "/assets/images/product-5.jpg",
          ratingImage: "/assets/images/stars-product.svg",
          title: "Life Boost Coffee",
          message: "Life Boost Coffee is more than just drinking coffee - it’s an experience that no one should miss. It’s smooth with no bitter aftertaste and it’s delightfully pleasant. I’m glad Life Boost Coffee found me.",
          reviewerName: "Everet K.",
          verifiedIcon: "/assets/images/verified-icon-new.jpg",
          productDetails: "3x Single Origin Medium Roast Coffee 12 oz Bag - One Bag Free"
        },
        {
          productImage: "/assets/images/product-3.jpg",
          ratingImage: "/assets/images/stars-product.svg",
          title: "My husband love it and",
          message: "My husband love it and I start drinking coffee too. Knowing it’s kosher and stomach friendly, that’s why I’m confident to drink it.",
          reviewerName: "Thelma K. ",
          verifiedIcon: "/assets/images/verified-icon-new.jpg",
          productDetails: "Single Origin Medium Roast Coffee 12 oz Bag - 1st bag free"
        },
        {
          productImage: "/assets/images/product-3.jpg",
          ratingImage: "/assets/images/stars-product.svg",
          title: "Fabulous Coffee",
          message: "We love Lifeboost coffee! been buying it for almost two years, with no plan to stop! Great taste, great value! Arrives right on time in super condition.",
          reviewerName: "Deborah E.",
          verifiedIcon: "/assets/images/verified-icon-new.jpg",
          productDetails: "Single Origin Dark Roast Coffee 12 oz Bag"
        },
        {
          productImage: "/assets/images/product-6.jpg",
          ratingImage: "/assets/images/stars-product.svg",
          title: "Best coffee I’ve ever had!!!",
          message: "This coffee is so good and so much flavor. The decaf process was so clean with no chemicals and still retains the flavor. I served it to guests from Hawaii and he just texted me on how wonderful the coffee was I and I didn’t tell him it was decaf.",
          reviewerName: "Kathleen M. ",
          verifiedIcon: "/assets/images/verified-icon-new.jpg",
          productDetails: "6x Decaf Coffee 12 oz Bag, Single Origin, Fair Trade Medium Roast\n"
        }
      ]
    },
    {
      name: "organicCoffeeSrc",
      type: "file",
      allowedFileTypes: [
        "jpeg",
        "jpg",
        "png",
        "svg"
      ],
      defaultValue: "/assets/images/product-organic.png"
    },
    {
      name: "organicCoffeeAlt",
      type: "text",
      defaultValue: "product-organic"
    },
    {
      name: "newStyle",
      type: "boolean",
      defaultValue: false
    }
  ]
});
</script>

<style>
.review-item-message:after,
.review-item-message:before {
  font-family: cursive;
  font-size: 20px;
  line-height: 10px;
}

.review-item-message:before {
  content: '" ';
}

.review-item-message:after {
  content: ' \201D';
}
</style>